/**
 * Used to circumvent Jest's limitation with ES modules which Vite depends on.
 * We basically route all environmental variables through this file/module so
 * we can easily mock the file in Jest.
 *
 * @see {@link https://stackoverflow.com/a/74882007}
 */

// NOTE: Read each variable as a specific `import.meta.env.VITE_*` member.
// Destructuring the bare `import.meta.env` object makes Vite inline the ENTIRE
// env object (every VITE_-prefixed variable) into the client bundle, which
// leaks any non-public value that merely happens to carry the VITE_ prefix.
const ENV_VERSION = import.meta.env.PACKAGE_VERSION
const ENV_PROD = import.meta.env.PROD
const ENV_ALGOLIA_API_KEY = import.meta.env.VITE_ALGOLIA_API_KEY
const ENV_ALGOLIA_APP_ID = import.meta.env.VITE_ALGOLIA_APP_ID
const ENV_ALGOLIA_ID = import.meta.env.VITE_ALGOLIA_ID
const ENV_ALGOLIA_INDEX_NAME = import.meta.env.VITE_ALGOLIA_INDEX_NAME
const ENV_ALGOLIA_INDEX_PRODUCTS = import.meta.env.VITE_ALGOLIA_INDEX_PRODUCTS
const ENV_ALGOLIA_SEARCH_ONLY_KEY = import.meta.env.VITE_ALGOLIA_SEARCH_ONLY_KEY
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT
const ENV_FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY
const ENV_FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID
const ENV_FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN
const ENV_FIREBASE_DB_URL = import.meta.env.VITE_FIREBASE_DB_URL
const ENV_FIREBASE_MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
const ENV_FIREBASE_MSG_SENDER_ID = import.meta.env.VITE_FIREBASE_MSG_SENDER_ID
const ENV_FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID
const ENV_FIREBASE_STORAGE_BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET
const ENV_GAE_REST_ENDPOINT = import.meta.env.VITE_GAE_REST_ENDPOINT
const ENV_GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY
const ENV_GRAPHQL_ENDPOINT = import.meta.env.VITE_GRAPHQL_ENDPOINT
const ENV_PEXELS_API_KEY = import.meta.env.VITE_PEXELS_API_KEY
const ENV_PLAID_ENDPOINT = import.meta.env.VITE_PLAID_ENDPOINT
const ENV_PLAID_ENV = import.meta.env.VITE_PLAID_ENV
const ENV_PLAID_PUBLIC_KEY = import.meta.env.VITE_PLAID_PUBLIC_KEY
const ENV_STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY

const ENV_FULLSTORY_ORGANIZATION_ID = 'TFYB4'
const ENV_SENTRY_DSN =
  'https://34c3e7aa785c4a9c916d8e38c2d5fd7c@o388880.ingest.sentry.io/5226303'

export {
  ENV_ALGOLIA_API_KEY,
  ENV_ALGOLIA_APP_ID,
  ENV_ALGOLIA_ID,
  ENV_ALGOLIA_INDEX_NAME,
  ENV_ALGOLIA_INDEX_PRODUCTS,
  ENV_ALGOLIA_SEARCH_ONLY_KEY,
  ENV_FIREBASE_API_KEY,
  ENV_FIREBASE_APP_ID,
  ENV_FIREBASE_AUTH_DOMAIN,
  ENV_FIREBASE_DB_URL,
  ENV_FIREBASE_MEASUREMENT_ID,
  ENV_FIREBASE_MSG_SENDER_ID,
  ENV_FIREBASE_PROJECT_ID,
  ENV_FIREBASE_STORAGE_BUCKET,
  ENV_FULLSTORY_ORGANIZATION_ID,
  ENV_GAE_REST_ENDPOINT,
  ENV_GOOGLE_MAPS_API_KEY,
  ENV_GRAPHQL_ENDPOINT,
  ENV_PEXELS_API_KEY,
  ENV_PLAID_ENDPOINT,
  ENV_PLAID_ENV,
  ENV_PLAID_PUBLIC_KEY,
  ENV_PROD,
  ENV_SENTRY_DSN,
  ENV_STRIPE_PUBLISHABLE_KEY,
  ENV_VERSION,
  ENVIRONMENT,
}
